<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="申请人信息：" prop="applicantInfo">
            <el-input v-model="query.applicantInfo" placeholder="请输入姓名/手机号" size="small" clearable />
          </el-form-item>
          <el-form-item label="用户信息：" prop="userInfo">
            <el-input v-model="query.userInfo" placeholder="请输入姓名/手机号" size="small" clearable />
          </el-form-item>
          <el-form-item label="用户身份：">
            <el-select v-model="query.userIdentity" placeholder="全部" clearable size="small" style="width: 120px;">
              <el-option v-for="item in identityList" :key="item.id" :label="item.name" :value="item.level" />
            </el-select>
          </el-form-item>
          <el-form-item label="城市公司：" prop="cityName">
            <el-input v-model="query.cityName" placeholder="请输入城市公司" size="small" clearable />
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small" style="width: 120px;">
              <el-option label="提交时间" :value="0" />
              <el-option label="审核时间" :value="1" />
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始" end-placeholder="结束" style="margin-left: 10px;" />
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({ pageNo: 1 })">
          <el-tab-pane label="待审核" name="0" />
          <el-tab-pane label="同意申请" name="1" />
          <el-tab-pane label="驳回申请" name="2" />
        </el-tabs>
        <div class="btn-box">
          <el-button type="primary" plain size="mini" @click="handleExport">导出</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" :key="activeName" style="width: 100%">
        <el-table-column label="申请人" prop="submitUserName" align="center" width="120">
        </el-table-column>
        <el-table-column label="申请人身份" prop="submitUserPosition" align="center" width="120"></el-table-column>
        <el-table-column label="申请人手机号" prop="submitUserPho" align="center" width="130">
        </el-table-column>
        <el-table-column label="申请内容" prop="applyContent" align="center" min-width="180">
          <template slot-scope="{ row }">
            {{ formatApplyContent(row) }}
          </template>
        </el-table-column>
        <el-table-column label="用户信息" prop="customerInfo" align="center" width="180">
        </el-table-column>
        <el-table-column label="业务发展线" prop="ywLine" align="center" width="120">
          <template slot-scope="{ row }">
            {{ formatYwLine(row) }}
          </template>
        </el-table-column>
        <el-table-column label="申请原因" prop="reason" align="center" width="120" show-overflow-tooltip />
        <el-table-column label="凭证" align="center" width="120">
          <template slot-scope="{ row }">
            <span class="imgs" v-if="getVoucherImages(row).length > 0">
              <el-image v-for="(item, index) in getVoucherImages(row)" :key="index"
                style="width: 40px; height: 40px; margin-right: 4px;" :src="item"
                :preview-src-list="getVoucherImages(row)" />
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="提交时间" prop="createdTime" align="center" width="180" />
        <el-table-column v-if="activeName === '1'" label="审核时间" prop="auditTime" align="center" width="180" />
        <el-table-column v-if="activeName === '1'" label="审核人" prop="auditUserName" align="center" width="120" />
        <el-table-column v-if="activeName === '2'" label="驳回时间" prop="auditTime" align="center" width="180" />
        <el-table-column v-if="activeName === '2'" label="驳回原因" prop="statereason" align="center" min-width="120"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column v-if="!recordOnly && activeName === '0'" label="操作" align="center" fixed="right" width="140">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleApprove(row)">同意</el-button>
            <el-button type="text" @click="handleReject(row)">驳回</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total > 0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>

    <approve-dialog v-if="!recordOnly" ref="approveDialog" @approve="handleApproveConfirm" />
    <reject-dialog v-if="!recordOnly" ref="rejectDialog" @reject="handleRejectConfirm" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import discountModificationAuditApi from '@/api/finance/discountModificationAudit'
import ApproveDialog from './approveDialog.vue'
import RejectDialog from './rejectDialog.vue'

export default {
  components: {
    Pagination,
    ApproveDialog,
    RejectDialog
  },
  props: {
    /** 仅记录模式，不显示操作按钮 */
    recordOnly: { type: Boolean, default: false }
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 20,
        applicantInfo: undefined,
        userInfo: undefined,
        userIdentity: undefined,
        cityName: undefined,
        timeType: undefined,
        auditStatus: undefined
      },
      dateTime: null,
      activeName: '0',
      identityList: []
    }
  },
  created() {
    this.identityList = JSON.parse(localStorage.getItem('levelList') || '[]')
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 20,
        applicantInfo: undefined,
        userInfo: undefined,
        userIdentity: undefined,
        cityName: undefined,
        timeType: undefined,
        auditStatus: undefined
      }
      this.dateTime = null
      this.doQueryList({ pageNo: 1 })
    },
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) this.query.pageNo = pageNo
      if (pageSize) this.query.pageSize = pageSize

      const params = {
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        nameOrPho: this.query.applicantInfo || '',
        customerNameOrPho: this.query.userInfo || '',
        customerLevel: this.query.userIdentity || '',
        cityName: this.query.cityName || '',
        position: '',
        startCreatedTime: '',
        endCreatedTime: '',
        startAuditTime: '',
        endAuditTime: ''
      }

      if (this.dateTime && this.dateTime.length === 2) {
        if (this.query.timeType === 0 || this.query.timeType === undefined) {
          params.startCreatedTime = this.dateTime[0]
          params.endCreatedTime = this.dateTime[1]
        } else if (this.query.timeType === 1) {
          params.startAuditTime = this.dateTime[0]
          params.endAuditTime = this.dateTime[1]
        }
      }

      params.state = this.activeName

      this.listLoading = true
      discountModificationAuditApi
        .fetchList(params)
        .then(data => {
          if (data && data.data) {
            this.list = data.data.list || data.data.records || []
            this.total = data.data.total || 0
          } else if (data && (data.list || data.records)) {
            this.list = data.list || data.records || []
            this.total = data.total || 0
          } else {
            this.list = []
            this.total = 0
          }
        })
        .catch(() => {
          this.list = []
          this.total = 0
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    formatUserInfo(row) {
      if (row.targetUserName && row.targetUserLevelName && row.targetUserMobile) {
        return `${row.targetUserName}-${row.targetUserLevelName}-${row.targetUserMobile}`
      }
      return row.userInfo || '-'
    },
    formatApplyContent(row) {
      if (row.fromProfitRatio !== undefined && row.toProfitRatio !== undefined) {
        return `原折扣: ${row.fromProfitRatio} 修改成: ${row.toProfitRatio}`
      }
      return null
    },
    formatYwLine(row) {
      const ywLine = [];
      if (row.ywLine5) {
        ywLine.push(row.ywLine5)
      }
      if (row.ywLine4) {
        ywLine.push(row.ywLine4)
      }
      if (row.ywLine3) {
        ywLine.push(row.ywLine3)
      }
      if (row.ywLine2) {
        ywLine.push(row.ywLine2)
      }
      if (row.ywLine1) {
        ywLine.push(row.ywLine1)
      }
      return ywLine.join(',')
    },
    getVoucherImages(row) {
      if (!row) return []
      if (row.imgUrl) {
        return row.imgUrl.split(',').filter(Boolean)
      }
      return []
    },
    handleApprove(row) {
      this.$refs.approveDialog.handleCreate(row)
    },
    handleApproveConfirm(params, callback) {
      discountModificationAuditApi
        .approve(params)
        .then(() => {
          this.$message.success('审核通过')
          this.doQueryList({})
          if (callback) callback()
        })
        .catch(err => {
          this.$message.error(err.msg || '审核失败')
          if (callback) callback()
        })
    },
    handleReject(row) {
      this.$refs.rejectDialog.handleCreate(row)
    },
    handleRejectConfirm(params, callback) {
      discountModificationAuditApi
        .reject(params)
        .then(() => {
          this.$message.success('已驳回')
          this.doQueryList({})
          if (callback) callback()
        })
        .catch(err => {
          this.$message.error(err.msg || '驳回失败')
          if (callback) callback()
        })
    },
    handleExport() {
      this.$router.push('/export/list?code=downloadChangProfitRatio')
    }
  }
}
</script>

<style scoped>
.imgs {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.btn-right-side {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mt10 {
  margin-top: 10px;
}

.mb10 {
  margin-bottom: 10px;
}
</style>
